<script lang="ts" setup>
    import { onMounted, reactive } from 'vue';
        
    import ResizeMonitor from '../../components/ResizeMonitor.vue'

    import '../../../css/choice.css'; 

    const props = defineProps<{
    }>(
    );

    const formData = reactive<{
        windowHeight: number,
    }>({
        windowHeight: 100,
    });

    onMounted(() => {
       windowResize();
    });

    function windowResize() {
        formData.windowHeight = window.innerHeight - 70;
    }
</script>

<template>
    <ResizeMonitor @resize="windowResize" />
    Placeholder for now.
</template>
